module.exports = __webpack_public_path__ + "static/media/designer-kids-wears-500x500.7874c766.jpeg";